import { render, staticRenderFns } from "./Specimens.vue?vue&type=template&id=4a6f0844"
import script from "./Specimens.vue?vue&type=script&lang=js"
export * from "./Specimens.vue?vue&type=script&lang=js"
import style0 from "./Specimens.vue?vue&type=style&index=0&id=4a6f0844&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports